import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import Grid from "@material-ui/core/Grid";
import "react-colorful/dist/index.css";

// components
import CircleButton from "core/CircleButton";
import BodyText from "core/BodyText";
import Tooltip from "core/Tooltip";
import ColorPicker from "icons/ColorPicker";
import EditorRotate from "./EditorRotate";
import EditorFlip from "./EditorFlip";

// styles
import colors from "core/colors";
import {
    IconEditorContainer,
    IconContainer,
    Icon,
    EditingDetailsContainer,
    EditingDetailsTopRow,
    EditingDetailsBottomRow,
    EditingSectionTitle,
    IconTransformControls,
    IconTransformControlGroup
} from "./styles";

// images
import Reset from "core/ReusableIcons/Reset";

import { useIconEditorState } from "js/contexts/IconEditorContext";

const IconEditor = ({ icon }) => {
    const state = useIconEditorState();
    const { iconColors, backgroundColors } = state;
    const { editorPreview } = state[icon.id] || {};

    const [reset, setReset] = useState(false);

    if (!icon) return null;

    return (
        <IconEditorContainer>
            <IconContainer color={backgroundColors.activeColor}>
                <Icon
                    data-testid="icon-editor-preview"
                    backgroundImage={`url("${editorPreview}")`}
                />
            </IconContainer>
            <EditingDetailsContainer>
                <EditingDetailsTopRow>
                    <BodyText type="p" size="md" copyColor={colors.midnight}>
                        Customize this icon
                    </BodyText>
                </EditingDetailsTopRow>
                <EditingDetailsBottomRow container>
                    <Grid container item xs direction="column">
                        <Grid container item xs>
                            <EditingSectionTitle>Icon</EditingSectionTitle>
                        </Grid>
                        <IconTransformControls>
                            <ColorPicker
                                colorState={iconColors}
                                id="icon-color"
                                title="Icon Color"
                                reset={reset}
                                handleReset={setReset}
                                activeColor={iconColors.activeColor}
                                recent={iconColors.recent}
                                palette={iconColors.palette}
                            />
                            <IconTransformControlGroup>
                                <EditorRotate
                                    iconId={icon.id}
                                    direction="ccw"
                                />
                                <EditorRotate iconId={icon.id} direction="cw" />
                            </IconTransformControlGroup>
                            <IconTransformControlGroup>
                                <EditorFlip iconId={icon.id} axis="y" />
                                <EditorFlip iconId={icon.id} axis="x" />
                            </IconTransformControlGroup>
                        </IconTransformControls>
                    </Grid>
                    <Grid container item xs direction="column">
                        <Grid container item xs>
                            <EditingSectionTitle>
                                Background Shape
                            </EditingSectionTitle>
                        </Grid>
                        <Grid container item xs>
                            <ColorPicker
                                colorState={backgroundColors}
                                id="background-color"
                                title="Background Color"
                                background
                                reset={reset}
                                handleReset={setReset}
                                activeColor={backgroundColors.activeColor}
                                recent={backgroundColors.recent}
                                palette={backgroundColors.palette}
                            />
                        </Grid>
                    </Grid>
                    <Grid
                        container
                        item
                        xs={1}
                        direction="column"
                        justify="flex-end"
                    >
                        <Tooltip message="Reset" size="small">
                            <CircleButton
                                type="button"
                                styleType="secondary"
                                size="sm"
                                icon={
                                    <Reset
                                        size="sm"
                                        fillColor={colors.fossil}
                                    />
                                }
                                title="reset color picker"
                                onClick={() => setReset(true)}
                            />
                        </Tooltip>
                    </Grid>
                </EditingDetailsBottomRow>
            </EditingDetailsContainer>
        </IconEditorContainer>
    );
};

IconEditor.propTypes = {
    icon: PropTypes.object
};

export default IconEditor;

// TODO: break this apart into smaller components so the file is easier to read
